import * as React from 'react';
import Column from '../Column';
import { Typography } from '@mui/material';

export interface Props {
  children: string;
  minHeigth?: number | string;
  testId?: string;
  align?: 'flex-start' | 'center' | 'flex-end' | 'inherit';
  padding?: number | string;
  sx?: React.CSSProperties;
}

const FailureScreen: React.FC<Props> = ({ children, minHeigth = 300, testId = 'failure-screen', align = 'center', padding = '0 40px', sx }) => (
  <Column
    grow
    centered
    testId={testId}
    style={{
      minHeight: minHeigth,
      padding: padding,
      alignItems: align,
      ...sx,
    }}
  >
    <Typography variant="body1" color="error" data-testid="failure-message">
      {children}
    </Typography>
  </Column>
);

export default FailureScreen;
